import React from "react";
import { ReactComponent as LogoSVG } from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";

const Logo = ({classes="max-w-md lg:py-5 mx-auto absolute left-10 top-5 md:z-0 z-10"}) => {
  return (
    <>
      <div className={classes}>
        <Link to="/">
          <LogoSVG />
        </Link>
      </div>
    </>
  );
};

export default Logo;
